import axios from '../../../services/axios.service';
import { getEndpointBase } from '../../../services/api.service';
import {
  CreateRegionDto,
  UpdateRegionDto,
  Region,
  RegionListResponse,
} from './RegionControl.type';
import { AxiosResponse } from 'axios';

let listRequest: any = null;

const REQUEST_PREFIX = 'region';

export const regionControlService = {
  getList: (params: {
    q?: string;
    page?: number | string;
    sort?: string;
  }): Promise<AxiosResponse<RegionListResponse>> => {
    listRequest && listRequest.cancel();
    listRequest = axios.CancelToken.source();

    return axios.get(getEndpointBase(`${REQUEST_PREFIX}`), {
      cancelToken: listRequest.token,
      params,
    });
  },

  create: (data: CreateRegionDto): Promise<AxiosResponse<Region>> => {
    return axios.post(getEndpointBase(`${REQUEST_PREFIX}`), data);
  },

  update: (data: UpdateRegionDto): Promise<AxiosResponse<Region>> => {
    return axios.put(getEndpointBase(`${REQUEST_PREFIX}/${data.id}`), data);
  },

  delete: (id: number): Promise<AxiosResponse> => {
    return axios.delete(getEndpointBase(`${REQUEST_PREFIX}/${id}`));
  },
};
